/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdApplicationPublicDataBuilderPublicDataBaseSupportOptions, FxIdApplicationPublicDataBuilderPublicDataBaseSupportOptionsFromJSONTyped, FxIdApplicationPublicDataBuilderPublicDataBaseSupportOptionsToJSON, } from './FxIdApplicationPublicDataBuilderPublicDataBaseSupportOptions';
export function FxIdApplicationPublicDataBuilderPublicDataBaseSupportFromJSON(json) {
    return FxIdApplicationPublicDataBuilderPublicDataBaseSupportFromJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPublicDataBaseSupportFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderPublicDataBaseSupportOptions(json)) {
        return FxIdApplicationPublicDataBuilderPublicDataBaseSupportOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdApplicationPublicDataBuilderPublicDataBaseSupportToJSON(json) {
    return FxIdApplicationPublicDataBuilderPublicDataBaseSupportToJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPublicDataBaseSupportToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderPublicDataBaseSupportOptions(value)) {
        return FxIdApplicationPublicDataBuilderPublicDataBaseSupportOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdApplicationPublicDataBuilderPublicDataBaseSupport.js.map